<template>
  <span>
    <span size="mini" v-if="state == 1">{{ getName(1) }}</span>
    <span size="mini" v-if="state == 2">{{ getName(2) }}</span>
    <span size="mini" v-if="state == 3">{{ getName(3) }}</span>
    <span size="mini" v-if="state == 4">{{ getName(4) }}</span>
    <span size="mini" v-if="state == 5">{{ getName(5) }}</span>
    <span size="mini" v-if="state == 6">{{ getName(6) }}</span>
  </span>
</template>

<script>
import { getName } from "./types.js";
export default {
  name: "l-consumable-log-type",
  props: {
    state: {
      type: [Number, String],
    },
  },

  methods: {
    getName(state) {
      return getName(state);
    },
  },
};
</script>
